<template>
	<header
		class="header"
		:class="{ header_home: $route.name === 'Home' }"
	>
		<div class="container desktop-or-home">
			<div class="row align-items-center">
				<div class="col">
					<router-link :to="{ name: 'Home' }">
						<img
							v-if="isThemeDark"
							class="header__logo"
							:src="`/img/logo-light_${$i18n.locale}.svg`"
							:alt="$t('company.name')"
						/>
						<template v-else>
							<img
								class="header__logo d-none d-sm-block"
								:src="`/img/logo-dark_${$i18n.locale}.svg`"
								:alt="$t('company.name')"
							/>
							<img
								class="header__logo d-sm-none"
								:src="`/img/logo-light_${$i18n.locale}.svg`"
								:alt="$t('company.name')"
							/>
						</template>
					</router-link>
				</div>

				<div class="col-auto">
					<div class="btn-group">
						<button
							v-for="lang in langs"
							:key="lang.val"
							class="btn-group__btn"
							:class="{ active: $i18n.locale == lang.val }"
							@click="setLang(lang.val)"
						>
							{{ lang.text }}
						</button>
					</div>
				</div>

				<div class="col-auto d-none d-md-block">
					<a
						:href="this.$t('company.telegram')"
						@click="fbqContact()"
						class="btn-circle"
					>
						<i class="icon icon-telegram"></i>
					</a>
				</div>

				<div class="col-auto d-none d-md-block">
					<button
						class="btn-primary small"
						@click="togglePopup('requestForm')"
					>
						<i class="gradient"></i> {{ $t('discussIdea') }}
					</button>
				</div>
			</div>
		</div>
		<div class="container mobile-not-home">
			<button
				class="btn-back"
				@click="$router.go(-1)"
			>
				{{ $t('back') }}
			</button>
		</div>
	</header>
</template>

<script>
export default {
	data() {
		return {
			langs: [
				{ val: 'ru', text: 'Рус' },
				{ val: 'en', text: 'Eng' },
			],
		}
	},

	computed: {
		isThemeDark() {
			return this.$store.getters['general/isThemeDark']
		},
	},

	methods: {
		togglePopup(name, show = true) {
			this.$store.dispatch('general/togglePopup', { name, show })
		},

		setLang(lang) {
			this.$store.dispatch('general/setUserLocale', lang)
		},

		fbqContact() {
			fbq('track', 'Contact')
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.header {
	padding: 28px 0;
	&__logo {
		width: 256px;
		height: auto;
		max-width: 100%;
		display: block;
		user-select: none;
	}
	.mobile-not-home {
		display: none;
	}
}

@media (max-width: $md) {
	.header {
		&.header_home {
			padding: 46px 0 8px;
		}
		&:not(.header_home) {
			padding: 10px 0;
			.mobile-not-home {
				display: block;
			}
			.desktop-or-home {
				display: none;
			}
		}
		&__logo {
			width: 200px;
		}
	}
}

@media (max-width: $sm) {
	.header {
		&__logo {
			width: 156px;
		}
	}
}
</style>
